import React from 'react';
import PropTypes from 'prop-types';
import { Bar } from './Bar';

const barsPropTypes = PropTypes.arrayOf(PropTypes.shape({
  x: PropTypes.number,
  y: PropTypes.number,
  width: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.string,
}));

/**
 * Generates a decorated CustomChartBars function component
 * This decorated Component will receive the
 * totalAnswerCount before being called.
 * @returns React.FC
 */
export const GenerateDecoratedCustomChartBarsFC = (props2) => {
  const {
    totalAnswerCount,
  } = props2;
  const DecoratedCustomChartBars = (props) => {
    const { bars, labelSkipWidth } = props;
    return (
      <CustomChartBars
        bars={bars}
        totalAnswerCount={totalAnswerCount}
        labelSkipWidth={labelSkipWidth}
      />
    );
  };

  DecoratedCustomChartBars.propTypes = {
    bars: barsPropTypes.isRequired,
    labelSkipWidth: PropTypes.number.isRequired,
  };

  return DecoratedCustomChartBars;
};

GenerateDecoratedCustomChartBarsFC.propTypes = {
  totalAnswerCount: PropTypes.number.isRequired,
};

export const CustomChartBars = (props) => {
  const {
    bars,
    totalAnswerCount,
    labelSkipWidth,
  } = props;

  const formatLabel = (formattedValue) => `${formattedValue} (${((Number(formattedValue) / (totalAnswerCount)) * 100).toFixed(0)
    }%)`;

  return (
    <>
      {bars.map(({
        key,
        x,
        y,
        width,
        height,
        color,
        data,
      }) => {
        const { formattedValue } = data;

        if (Number(formattedValue) === 0) {
          return null;
        }

        return (
          <Bar
            key={key}
            x={x}
            y={y}
            label={formatLabel(formattedValue)}
            width={width}
            height={height}
            color={color}
            labelSkipWidth={labelSkipWidth}
          />
        );
      })}

    </>
  );
};

CustomChartBars.propTypes = {
  bars: barsPropTypes.isRequired,
  totalAnswerCount: PropTypes.number.isRequired,
  labelSkipWidth: PropTypes.number.isRequired,
};
